export default __webpack_public_path__ + "static/media/kxwlogo.a2ad0cbf.webp";